// custom AB tests

export default function abTestGoal() {
	window.dataLayer = window.dataLayer || [];
	if (window.abTestGoal !== false) {
		const randomNumber = Math.floor(Math.random() * 101);
		const percentageTestA = 80;

		if (localStorage.getItem('abTestGoal') === null) {
			if (randomNumber < percentageTestA) {
				localStorage.setItem('abTestGoal', 'A');
			} else {
				localStorage.setItem('abTestGoal', 'B');
			}
		}
		if (localStorage.getItem('abTestGoal') === 'B') {
			window.abTestGoal = false;
			window.dataLayer.push({
				event: 'AB_TEST',
				ab_name: 'goal_1',
				ab_group: 'B',
				ab_test_type: 'quiz',
			});
		} else {
			window.abTestGoal = false;
			window.dataLayer.push({
				event: 'AB_TEST',
				ab_name: 'goal_1',
				ab_group: 'A',
				ab_test_type: 'quiz',
			});
		}
	}
}
